import AppConstants from 'constants/AppConstants';

export function setCurrentSearch(value: string): BaseTockAction {
  if (value.length === 1) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).analytics.sendEvent('Global nav', 'Search started');
  }
  return {
    payload: value,
    type: AppConstants.SEARCH_SET,
  };
}

export function clearSearchResults(): BaseTockAction {
  return {
    type: AppConstants.CLEAR_SEARCH_RESULTS,
  };
}
